import React from 'react';
import { useParentChild } from '../../contexts/ParentChildContext';

const ChildSelector = () => {
  const { children, selectedChild, selectChild, loading } = useParentChild();

  if (loading) return null;
  if (!children.length) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-sm text-amber-800">
        Aucun enfant inscrit pour l'année en cours.
      </div>
    );
  }

  if (children.length === 1) {
    const c = children[0];
    return (
      <div className="bg-white border border-slate-200 rounded-xl px-4 py-3 flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-sm font-bold">
          {c.prenom?.[0]}{c.nom?.[0]}
        </div>
        <div>
          <p className="font-medium text-slate-900">{c.prenom} {c.nom}</p>
          <p className="text-xs text-slate-500">{c.classe} — {c.annee_scolaire}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-slate-200 rounded-xl px-4 py-3">
      <label className="block text-xs font-medium text-slate-500 mb-1.5">Sélectionner un enfant</label>
      <select
        value={selectedChild?.inscription_id || ''}
        onChange={(e) => {
          const child = children.find((c) => String(c.inscription_id) === e.target.value);
          if (child) selectChild(child);
        }}
        className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm text-slate-900"
      >
        {children.map((c) => (
          <option key={c.inscription_id} value={c.inscription_id}>
            {c.prenom} {c.nom} — {c.classe}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ChildSelector;
